import React from "react";

import { css, cx } from "@emotion/css";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Patient } from "@/models/PatientModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type DailyFileReportProps = {
  patient: Patient;
  date: DateTime;
  className?: string;
};

const DailyFileReportEmbed: React.FC<DailyFileReportProps> = ({ className, patient, date }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  const fileReport = Queries.diabetes.useFileReport({
    patientId: patient.id,
    date,
  });

  return (
    <div className={cx(styles.container, className)}>
      {fileReport ? (
        <embed src={fileReport.file.url} className={styles.file} type="application/pdf" />
      ) : (
        <Typography>{t("fileReports.noData")}</Typography>
      )}
    </div>
  );
};
export default DailyFileReportEmbed;

const makeStyles = () => ({
  container: css({
    display: "flex",
    width: "100%",
    minHeight: "100vh",
  }),
  file: css({
    width: "100%",
    flex: "1 1 auto",
  }),
});
